module.exports = __webpack_public_path__ + "static/media/loading.166dc400.gif";